import {
  login as loginFire,
  logout as logoutFire
} from '@mizz/penny-firebase/repositories/auth'
import store from '@/store'
import router from '@/router'

export function login() {
  return loginFire()
    .then((user) => {

      store.commit({
        type: 'user/registerUser',
        user
      })
      sessionStorage.setItem('user', JSON.stringify(user))

      router.push({ name: 'home' })
    })
}

export function logout() {
  return logoutFire().then(() => {
    store.commit({
      type: 'user/registerUser',
      user: null
    })
    sessionStorage.removeItem('user')
  })
}

function getSessionUser() {
  const sessionUser = sessionStorage.getItem('user')
  let user = null

  try {
    if (sessionUser) {
      user = JSON.parse(sessionUser)
    }
  } catch (err) {
    console.error(err)
  }

  return user
}

export function isAuthenticated() {
  const user = getSessionUser()

  if (!user) {
    return false
  }

  store.commit({
    type: 'user/registerUser',
    user
  })

  return true
}

export function getCurrentUserId() {
  return (getSessionUser() || {}).uid
}
